import { exhaustMap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { mapResponse } from '@ngrx/operators';
import { signalStoreFeature } from '@ngrx/signals';
import { Events, withEventHandlers } from '@ngrx/signals/events';
import { VesselReportsService } from '../vessel-reports-service/vessel-reports.service';
import { vesselReportsEvents } from './vessel-reports-events';

export function withVesselReportsEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      const events = inject(Events);
      const vesselReportsService = inject(VesselReportsService);

      return {
        fetchVesselReports$: events.on(vesselReportsEvents.fetchVesselReports).pipe(
          exhaustMap(({ payload: vesselId }) =>
            vesselReportsService.getVesselReports(vesselId).pipe(
              mapResponse({
                next: (reports) => vesselReportsEvents.fetchedVesselReports(reports),
                error: console.error,
              })
            )
          )
        ),
      };
    })
  );
}
